export enum GameState {
    Intro,
    InProgress,
    ReadyToCast,
    Success,
    Fail
}
